import axios from "axios";
import { API_BASE_URL } from "../config/api";

// Create a function that returns the Axios instance with dynamic headers
const instance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  },
});
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log("error>>>>>>",error)
    if (error.response && (error.response.data?.error === "User Doesn't Exist" || error.response.data?.error === "Invalid User")) {
      if(localStorage.getItem("token")){
        logoutUser();

      }
    }
    return Promise.reject(error);
  }
);
const logoutUser = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("isLoggedIn");
  localStorage.removeItem("user");
  localStorage.removeItem("isJoint");
  localStorage.removeItem("adminCode");
  window.location.href = "/login"; 
};
const updateInstance = (token) => {
  // Interceptor to update Authorization header whenever the token changes
  if (token) {
    instance.defaults.headers["Authorization"] = `Bearer ${token}`;
  }
  console.log("token>>>>>>>>>>>>", token);
  // instance.interceptors.request.use((config) => {

  //   console.log("configconfigconfigconfigconfigconfig",config)
  //   return config;
  // });

  return instance;
};

export default updateInstance;

export const getEnrollmentAmount = (code, role = "user") =>
  instance.post(`${role}/getAmount`, { code });

export const CustomReport = async (pageNo, values) => {
  return await instance.post(`admin/completeReport/${pageNo}`, values);
}; 

export const FreeWaiverReportAPI = async (pageNo, values) => {
  return await instance.post(`admin/waiver-student-report/${pageNo}`, values);
};

export const completeReportCSV = async (values) => {
  return await instance.post(`admin/completeReportCSV`, values, {
    responseType: "blob",
  });
};
export const phoneCourseReportCSV = async (values) => {
  return await instance.post(`admin/phone-course-report-csv`, values, {
    responseType: "blob",
  });
};
export const PhoneCourseReportAPI = async (pageNo, values) => {
  return await instance.post(`admin/phone-course-report/${pageNo}`, values);
};
export const LanguageReportAPI = async (pageNo, values) => {
  return await instance.post(`admin/language-report/${pageNo}`, values);
};

export const RetakeReportAPI = (pageNo, values) =>
  instance.post(`admin/retake-report/${pageNo}`, values);

export const retakeReportCSV = (values) =>
  instance.post('admin/retake-report-csv', values, { responseType: 'blob' });

export const languageReportCSV = async (values) => {
  return await instance.post(`admin/language-report-csv`, values, {
    responseType: "blob",
  });
};

export const GetLanguagesAPI = async () => {
  return await instance.get(`admin/get-languages/1`);
};

export const clientReportCSV = async (values) => {
  return await instance.post(`attorney/export_fetch_student_detail`, values);
};
export const freeWavierReportCSV = async (values) => {
  return await instance.post(`admin/waiver-student-report-csv`, values, {
    responseType: "blob",
  });
};

export const SurveyReportAPI = async (pageNo, values) => {
  return await instance.post(`admin/survey-report/${pageNo}`, values);
};

export const surveyReportCSV = async (values) => {
  return await instance.post(`admin/survey-report-csv`, values, {
    responseType: "blob",
  });
};

export const UpdateUserInfor = async (values,id,type = "User") => {
  const userType =  type == "Admin" ? "admin": "user"
  // console.log("asdgdsagasfda",values,id,userType)
  return await instance.post(`${userType}/update-new-user/${id}`, values);
};
export const AddJointUser = async (values) => {
  return await instance.post(`user/add-user-joint`, values);
};
export const AddAttorneyAssociate = async (values) => {
  return await instance.post(`user/attorney-associate`, values);
};

// Signup
export const userSignup = async (body) => {
  return await instance.post(`user/register`, body);
};

export const userSignupWithShortDet = async (body) => {
  return await instance.post(`user/new-register`, body);
};

export const getAttCode = async (body) => {
  return await instance.post(`attorney/fetch_attorney_code`, body);
};

// Login
export const userLogin = async (body) => {
  return await instance.post(`user/login`, body);
};

// forgot password
export const forgotPassword = async (body) => {
  return await instance.post(`user/reset-password`, body);
};

// reset password
export const resetPassword = async (body) => {
  return await instance.post(`user/forgot-password`, body);
};

// get the user data for edit
export const userEdit = async (id) => {
  return await instance.get(`user/get_user_id/${id}`);
};
export const userinfo = async (id) => {
  return await instance.get(`user/get_user_id/${id}`);
};

// update the user data for edit
export const userUpdate = async (values, id) => {
  return await instance.post(`user/update-user/${id}`, values);
};
// get the state data in dropdown
export const getStates = async () => {
  return await instance.get(`user/get_state`);
};

export const addLanguage = async (values) => {
  return await instance.post(`user/add_language`, values);
};
//
export const VerifyUser = async (body) => {
  return await instance.post(`attorney/check_attorney_code`, body);
};

// get the county data in dropdown
export const getCounty = async (body) => {
  return await instance.post(`user/get_state_county`, body);
};

// get the district data in dropdown
export const getDistrict = async (body) => {
  return await instance.post(`user/get_state_district`, body);
};

// enroll the 1st Course
export const enrollCourse = async (type, id, values) => {
  return await instance.post(`${type}/enroll_first/${id}`, values);
};

// enroll the 2st Course
export const enroll2ndCourse = async (type, id, values) => {
  return await instance.post(`${type}/enroll_second/${id} `, values);
};

export const updateBankruptcy = async (type, id, values) => {
  return await instance.post(`${type}/case_number/${id} `, values);
};

export const couponCodeCalculator = async (type, values) => {
  return await instance.post(`${type}/coupon_code_calculator`, values);
};

export const updateCourseInvoice = async (type, values) => {
  return await instance.post(`${type}/stripe_payment`, values);
};

// render dashBoard according to the course status
export const getDashboard = async (type, id, query = "false") => {
  return await instance.get(`${type}/userDashboard/${id}?isJoint=${query}`);
};

// render 1st course
export const courseData = async (type, id, query = "false", retake) => {
  return await instance.post(
    `${type}/course_first_data/${id}?isJoint=${query}&retake=${retake}`
  );
};
export const latestcourseData = async (
  type,
  id,
  query = "false",
  retake,
  view = {}
) => {
  return await instance.post(
    `${type}/course_first_new_data/${id}?isJoint=${query}&retake=${retake}`,
    view
  );
};

// how'd this happen 1st course
export const howDidHappen = async (type, values) => {
  return await instance.post(`${type}/how_did_happen`, values);
};

// evaluate 1st course
export const evaluateData = async (id, values, query = "false", retake) => {
  return await instance.post(
    `user/evaluation/${id}?isJoint=${query}&retake=${retake}`,
    values
  );
};

// update 1st course
export const courseUpdate = async (
  type,
  id,
  values,
  query = "false",
  retake
) => {
  return await instance.post(
    `${type}/course_first_updation/${id}?isJoint=${query}`,
    { ...values, retake: retake }
  );
};

export const latestcourseUpdate = async (
  type,
  id,
  values,
  query = "false",
  retake
) => {
  return await instance.post(
    `${type}/course_first_new_updation/${id}?isJoint=${query}`,
    { ...values, retake: retake }
  );
};

export const saveQuizFirst = async (
  type,
  id,
  values,
  query = "false"
) => {
  return await instance.post(
    `${type}/quiz_first/${id}?isJoint=${query}`,
    values
  );
};
export const userAssessment = async (type, id, values) => {
  return await instance.post(
    `${type}/user_assessment`,
    values
  );
};
export const getUserAssessment = async (type, id) => {
  return await instance.get(`${type}/user_assessment/${id}`);
};

export const getClassFiveBudget = async (type, id) => {
  return await instance.get(`${type}/class_five_budget/${id}`);
};

export const saveClassFiveBudget = async (type, id, section, values) => {
  return await instance.post(
    `${type}/class_five_budget/${id}/${encodeURIComponent(section)}`,
    values
  );
};

export const emailClassFiveBudgetReport = async (type, id, values) => {
  return await instance.post(
    `${type}/class_five_budget/${id}/report-email`,
    values
  );
};

// update 1st course
export const setSecurityQuestion = async (id, values) => {
  return await instance.post(`user/add_security_question/${id}`, values);
};

// render 2nd course
export const courseData2 = async (type, id, query = "false", retake) => {
  return await instance.post(
    `${type}/course_second_data/${id}?isJoint=${query}&retake=${retake}`
  );
};

// update 2nd course
export const courseUpdate2 = async (
  type,
  id,
  values,
  query = "false",
  retake
) => {
  return await instance.post(
    `${type}/course_second_updation/${id}?isJoint=${query}`,
    { ...values, retake: retake }
  );
};

// Register User with attorney code
export const fetchAttorney = async (values) => {
  return await instance.post(`attorney/fetch_attorney`, values);
};

//edit attorney
export const downloadBudget = async (id, values) => {
  return await instance.post(`user/download-budget/${id}`, values);
};

// Submit Budget analysis
export const budgetAnalysis = async (values, type, userId) => {
  return await instance.post(`${type}/budget_analysis${"/" + userId}`, values);
};

// Submit Budget analysis
export const getBudgetAnalysis = async (id, type) => {
  return await instance.get(`${type}/get_budget_analysis/${id}`);
};

// get Budget analysis
export const getBudgetAnalysisSecond = async (id, type) => {
  return await instance.get(`${type}/get_budgetAnalysis_second/${id}`);
};
// Submit Budget analysis
export const postBudgetAnalysisSecond = async (id, type, values) => {
  return await instance.post(`${type}/budgetAnalysis_second/${id}`, values);
};

// Submit Budget analysis
export const BudgetAnalysisSecond = async (values, type, userId) => {
  return await instance.post(`${type}/networth_second${"/" + userId}`, values);
};

// Submit Second Review Questions
export const quizSecond = async (
  values,
  type,
  userId,
  query = "false",
  retake
) => {
  return await instance.post(
    `${type}/quiz_second${"/" + userId}?isJoint=${query}&retake=${retake}`,
    values
  );
};

// Save the survey displayed before the DE course review questions.
export const saveCourseSurvey = async (
  answers,
  type,
  userId,
  isJoint = false,
  retake = false
) => {
  const endpoint =
    type === "admin" ? `admin/course-survey/${userId}` : "user/course-survey";
  return await instance.post(
    `${endpoint}?isJoint=${isJoint}&retake=${retake ? 1 : 0}`,
    { answers }
  );
};

// Submit Budget analysis
export const changePassword = async (values) => {
  return await instance.post(`user/change-password`, values);
};
export const getBudgetanalysisData = async (id) => {
  return await instance.get(`user/get_budget_analysis_summary/${id}`);
};

// send contact
export const sendContactQuery = async (values) => {
  return await instance.post(`attorney/contact_us`, values);
};

// // US country States api
// export const getStates=()=>{
//     return instance.get(`states`)
// }

// ADMIN ENDPOINTS

// get all students
export const getAdminDashboard = async () => {
  return await instance.get(`admin/admin_dashboard`);
};

export const getAdminDashboardCardDats = async (
  url,
  pageNo,
  statCourse,
  restQuery = ""
) => {
  return await instance.get(
    `admin/${url}/${pageNo}?course=${statCourse}${restQuery}`
  );
};

export const getAdminDashboardCertData = async (
  url,
  statCourse,
  restQuery = ""
) => {
  return await instance.get(`admin/${url}?course=${statCourse}${restQuery}`);
};

export const getAdminDashboardCSV = async (values) => {
  return await instance.post(`admin/make_csv`, values, {
    responseType: "blob",
  });
};

// get all students
export const getAllStudents = async (pageNo) => {
  return await instance.get(`admin/students_course_detail/${pageNo}`);
};

// search student
export const searchStudents = async (pageNo, searchKey) => {
  return await instance.post(
    `admin/search_students_course_detail/${pageNo}`,
    searchKey
  );
};

export const getAllGladeStudents = async (pageNo) => {
  return await instance.get(`admin/glade_students_course_detail/${pageNo}`);
};

export const searchGladeStudents = async (pageNo, searchKey) => {
  return await instance.post(
    `admin/search_glade_students_course_detail/${pageNo}`,
    searchKey
  );
};

export const getGladeStudentDetail = async (id) => {
  return await instance.get(`admin/glade_student_detail/${id}`);
};

export const updateGladeStudentDetail = async (id, values) => {
  return await instance.put(
    `admin/update_glade_student_detail/${encodeURIComponent(id)}`,
    values
  );
};

export const getGladeCourseProgress = async (id, course) => {
  return await instance.get(
    `admin/glade_student_course_progress/${encodeURIComponent(
      id
    )}?course=${encodeURIComponent(course)}`
  );
};

export const updateGladeCourseProgress = async (id, course, data) => {
  return await instance.put(
    `admin/update_glade_student_course_progress/${encodeURIComponent(id)}`,
    { course, data }
  );
};

export const getGladeBudgetAnalysisAdmin = async (clientId) => {
  return await instance.get(
    `admin/glade/get_budget_analysis/${encodeURIComponent(clientId)}`
  );
};

export const saveGladeBudgetAnalysisAdmin = async (clientId, values) => {
  return await instance.post(
    `admin/glade/budget_analysis/${encodeURIComponent(clientId)}`,
    values
  );
};

export const getGladeBudgetAnalysisSummaryAdmin = async (clientId) => {
  return await instance.get(
    `admin/glade/get_budget_analysis_summary/${encodeURIComponent(clientId)}`
  );
};

const encodeGladeCertificateParams = (isJoint) =>
  btoa(JSON.stringify({ isJoint: Boolean(isJoint) }));

export const generateGladeCourseFirstCertificate = async (
  clientId,
  isJoint = false
) => {
  return await instance.post(
    `admin/glade/course1_generate_certificate/${encodeURIComponent(clientId)}?params=${encodeURIComponent(
      encodeGladeCertificateParams(isJoint)
    )}`
  );
};

export const generateGladeCourseSecondCertificate = async (
  clientId,
  isJoint = false
) => {
  return await instance.post(
    `admin/glade/course2_generate_certificate/${encodeURIComponent(clientId)}?params=${encodeURIComponent(
      encodeGladeCertificateParams(isJoint)
    )}`
  );
};

export const uploadGladeManualCertificate = async (
  clientId,
  courseCode,
  isJoint,
  file
) => {
  const data = new FormData();
  data.append("courseCode", courseCode);
  data.append("file", file);

  return await instance.post(
    `admin/glade/manual_certificate/${encodeURIComponent(clientId)}?params=${encodeURIComponent(
      encodeGladeCertificateParams(isJoint)
    )}`,
    data
  );
};

// delete student
export const deleteStudent = async (id, pageNo) => {
  return await instance.delete(`admin/delete_user/${id}/${pageNo}`);
};

// delete attorney
export const deleteAttorney = async (id, pageNo) => {
  return await instance.delete(`admin/delete-attorney/${id}/${pageNo}`);
};

export const deleteJointInfo = async (id) => {
  return await instance.delete(`admin/delete_joint/${id}`);
};

// get the user data for edit
export const getUserData = async (id, query = "?type=User") => {
  return await instance.get(`admin/get_user_detail/${id}${query}`);
};

// get the user data for retake
export const getUserRetakeData = async (id, query = "?type=User") => {
  return await instance.get(`admin/retake_course_detail/${id}${query}`);
};

export const getCourseSurveyAdmin = async (
  id,
  isJoint = false,
  retake = false
) => {
  return await instance.get(
    `admin/course-survey/${id}?isJoint=${isJoint}&retake=${retake ? 1 : 0}`
  );
};

// get the budget analysis summary of specific user
export const getBudgetanalysisDataAdmin = async (id) => {
  return await instance.get(`admin/get_budget_analysis_summary/${id}`);
};

export const getBudgetanalysisOverviewDataAdminNew = async (id) => {
  return await instance.get(`admin/get_budget_summery_overview_new/${id}`);
};

// get the course progress of specific user
export const getCourseProgress = async (id, course) => {
  return await instance.post(`admin/fetch_student_course_detail/${id}`, course);
};

// update the course progress of specific user
export const updateCourseProgress = async (id, data) => {
  return await instance.post(`admin/update_user_course_detail/${id}`, data);
};

// update profile
export const updateProfile = async (id, values) => {
  return await instance.post(`admin/update_user/${id}`, values);
};
export const updateNote = async (values) => {
  return await instance.post(`attorney/save-note`, values);
};

// update profile
export const updateProfileByUser = async (id, values) => {
  return await instance.post(`user/update_user/${id}`, values);
};

// get all attormney
export const getAllAttorney = async (pageNo) => {
  return await instance.get(`admin/fetch_attorney/${pageNo}`);
};

// search attorney
export const searchAttorney = async (pageNo, searchKey) => {
  return await instance.post(`admin/search_attorney/${pageNo}`, searchKey);
};

// get all clients
export const getAttorneyClients = async (pageNo, attorney) => {
  return await instance.post(`admin/fetch_student_detail/${pageNo}`, attorney);
};

// search clients
export const searchAttorneyClients = async (pageNo, values) => {
  return await instance.post(
    `admin/fetch_search_student_detail/${pageNo}`,
    values
  );
};

//edit attorney
export const editAttorney = async (id, values) => {
  return await instance.post(`admin/edit_account/${id}`, values);
};

// languages
export const getLanguages = async (pageNo) => {
  return await instance.get(`admin/get_languages/${pageNo}`);
};

export const deleteLanguage = async (id, pageNo) => {
  return await instance.delete(`admin/delete_languages/${id}/${pageNo}`);
};

// attorney contact
export const getAttorneyContact = async (pageNo) => {
  return await instance.get(`attorney/all_attorney/${pageNo}`);
};
export const addAttorneyContact = async (values) => {
  return await instance.post(`attorney/add_attorney`, values);
};
export const deleteAttorneyContact = async (id, pageNo) => {
  return await instance.delete(`attorney/delete_attorney/${id}/${pageNo}`);
};

//Attorney code
export const getAttorneyData = async (pageNo) => {
  return await instance.get(`admin/fetch_attorney_code/${pageNo}`);
};
export const searchAttorneyCodes = async (pageNo, search) => {
  return await instance.get(`admin/search_attorney_code/${pageNo}`, { params: { search } });
};
export const deleteAtterneyCode = async (id, pageNo) => {
  return await instance.delete(`admin/delete_attorney_code/${id}/${pageNo}`);
};
export const updateDiscount = async (id, discountValue) => {
  const value = { discount: discountValue };
  return await instance.post(`admin/update_attorney_code/${id}`, value);
};
// coupons
export const getCoupons = async (pageNo) => {
  return await instance.get(`admin/get_coupon/${pageNo}`);
};
export const addCoupons = async (values) => {
  return await instance.post(`admin/add_coupon`, values);
};
export const deleteCoupons = async (id, pageNo) => {
  return await instance.delete(`admin/delete_coupon/${id}/${pageNo}`);
};

// pending billing course first
export const getBillingFirst = async (pageNo) => {
  return await instance.get(`admin/new_pending_billing/${pageNo}?course=first`);
};

export const getPendingInvoiceHistory = async (pageNo,course,search,status) => {
  return await instance.get(`admin/attorney_invoice_history/${pageNo}?course=${course}&search=${search}&status=${status}`);
};

export const getAttorneyBilling = async (pageNo,course) => {
  return await instance.get(`admin/attorney_pending_billing/${pageNo}?course=${course}`);
};
export const AttorneyPendingBillingUser = async (data) => {
  return await instance.post(`admin/attorney_pending_billing_user_list`,data);
};

export const AttorneyPendingBillingUserByFilter = async (data,monthFilter="current") => {
  return await instance.post(`admin/attorney_pending_billing_user_list?month=${monthFilter}`,data);
};


export const exportAtorneyInvoice = async (data) => {
  return await instance.post(`admin/export_attorney_invoice`,data);
};

export const getGladePendingBilling = async (
  course = "all",
  month = "all",
  billingBasis = "completion"
) => {
  return await instance.get(
    `admin/glade_pending_billing?course=${course}&month=${month}&billingBasis=${billingBasis}`
  );
};

export const exportGladeInvoice = async (data) => {
  return await instance.post(`admin/export_glade_invoice`, data);
};

export const getGladeInvoiceHistory = async (pageNo, course, status) => {
  return await instance.get(
    `admin/glade_invoice_history/${pageNo}?course=${course}&status=${status}`
  );
};

export const updateGladeInvoice = async (values) => {
  return await instance.post(`admin/update_glade_invoice_paid_status`, values);
};

export const updateBillingFirst = async (values, pageNo) => {
  return await instance.post(
    `admin/update_pending_billing/${pageNo}?course=first`,
    values
  );
};

export const updateAttorneyInvoice = async (values) => {
  return await instance.post(
    `admin/update_attorney_invoice_paid_status`,
    values
  );
};

// pending billing course second
export const getBillingSecond = async (pageNo) => {
  return await instance.get(
    `admin/new_pending_billing/${pageNo}?course=second`
  );
};
export const updateBillingSecond = async (values, pageNo) => {
  return await instance.post(
    `admin/update_pending_billing/${pageNo}?course=second`,
    values
  );
};

// get evaluation first course
export const getEvaluationFirst = async () => {
  return await instance.get(`admin/evaluation_stat_first`);
};
export const searchEvaluationFirst = async (values) => {
  return await instance.post(`admin/evaluation_stat_first_search`, values);
};

// get evaluation second course
export const getEvaluationSecond = async () => {
  return await instance.get(`admin/evaluation_stat_second`);
};
export const searchEvaluationSecond = async (values) => {
  return await instance.post(`admin/evaluation_stat_second_search`, values);
};

// attorney invoice
export const getAttorneInvoice = async (pageNo, course) => {
  return await instance.post(`admin/attorney_invoice/${pageNo}`, course);
};
export const updateAttorneInvoice = async (pageNo, values) => {
  return await instance.post(`admin/update_invoice/${pageNo}`, values);
};

// card orders
export const getCardOrder = async (pageNo) => {
  return await instance.get(`admin/cards_request/${pageNo}`);
};
export const updateCardOrder = async (values, pageNo) => {
  return await instance.post(`admin/update_cards_request/${pageNo}`, values);
};

// booklets
export const getAllCCBooklet = async (pageNo) => {
  return await instance.get(`admin/get_booklet_first/${pageNo}`);
};
export const getAllDEBooklet = async (pageNo) => {
  return await instance.get(`admin/get_booklet_second/${pageNo}`);
};
export const updateBooklet = async (id, values) => {
  return await instance.post(`admin/upadte_booklet_record/${id}`, values);
};

// certificates
export const getAllCert = async (pageNo) => {
  return await instance.get(`admin/certificate_info/${pageNo}`);
};
export const getGladePendingCertificates = async (pageNo) => {
  return await instance.get(`admin/glade_pending_certificate_info/${pageNo}`);
};
export const getAllInProgressPhoneCourses = async (pageNo) => {
  return await instance.get(`admin/inprogress-phone-course/${pageNo}`);
};
export const getIncompleteCertificates = async (pageNo) => {
  return await instance.get(`admin/follow_up_without_info/${pageNo}`);
};
export const getAllCertRetake = async (pageNo) => {
  return await instance.get(`admin/retake_certificate_info/${pageNo}`);
};
export const generateCert = async (id, values, query = "false") => {
  return await instance.post(
    `admin/generate_certificate/${id}?isJoint=${query}`,
    { ...values, retake: 0 }
  );
};
export const generateCertRetake = async (id, values, query = "false") => {
  return await instance.post(
    `admin/generate_certificate/${id}?isJoint=${query}`,
    { ...values, retake: 1 }
  );
};
// export const resendCert = async (values) => {
//   return await instance.post(`admin/resend_certificate`, values);
// };
export const resendCert = async (values) => {
  return await instance.post(`admin/resend_cert_to_user`, values);
};
export const resendCertToAttorney = async (values) => {
  return await instance.post(`admin/resend_cert_to_attorney`, values);
};
// export const resendCertRetake = async (values) => {
//   return await instance.post(`admin/resend_certificate`, {
//     ...values,
//     retake: 1,
//   });
// };
export const resendCertRetake = async (values) => {
  return await instance.post(`admin/resend_cert_to_user`, {
    ...values,
    retake: 1,
  });
};
export const resendCertRetakeToAttorney = async (values) => {
  return await instance.post(`admin/resend_cert_to_attorney`, {
    ...values,
    retake: 1,
  });
};
export const generateCertSecond = async (id, values) => {
  return await instance.post(`admin/generate_certificate_second/${id}`, {
    ...values,
    retake: 0,
  });
};
export const generateCertSecondRetake = async (id, values) => {
  return await instance.post(`admin/generate_certificate_second/${id}`, {
    ...values,
    retake: 1,
  });
};
export const retakeCCCourse = async (id) => {
  return await instance.get(`admin/retake_course_first/${id}`);
};
export const retakeDECourse = async (id) => {
  return await instance.get(`admin/retake_course_second/${id}`);
};
export const uploadCert = async (id, values, query = "false") => {
  return await instance.post(
    `admin/manual_certificate/${id}?isJoint=${query}`,
    values
  );
};
export const uploadCertRetake = async (id, values, query = "false") => {
  return await instance.post(
    `admin/manual_certificate/${id}?isJoint=${query}`,
    values
  );
};
export const uploadCertToCourt = async (id, values) => {
  return await instance.post(`admin/upload_court_cert/${id}`, values);
};
export const getFollowup = async (pageNo) => {
  return await instance.get(`admin/follow_up/${pageNo}`);
};
export const getGladeFollowup = async (pageNo) => {
  return await instance.get(`admin/glade_follow_up/${pageNo}`);
};
export const getGladeFollowupDetail = async (id, courseId) => {
  return await instance.get(
    `admin/glade_follow_up_detail/${encodeURIComponent(id)}?courseId=${encodeURIComponent(
      courseId
    )}`
  );
};

export const getFollowupRetake = async (pageNo) => {
  return await instance.get(`admin/retake_follow_up/${pageNo}`);
};
export const updateFollowUp = async (id, values) => {
  return await instance.post(`admin/follow_up/${id}`, values);
};
export const updateGladeFollowUp = async (id, values) => {
  return await instance.post(
    `admin/glade_follow_up/${encodeURIComponent(id)}`,
    values
  );
};
export const updateFollowUpRetake = async (id, values) => {
  return await instance.post(`admin/retake_follow_up/${id}`, values);
};

// ATTORNEY ENDPOINTS

// get all students
// export const getAllClients = async (pageNo, attorney) => {
//   return await instance.post(
//     `attorney/fetch_student_detail/${pageNo}`,
//     attorney
//   );
// };
export const getAllClients = async (pageNo, filters = {}) => {
  // filters can include: attorneyname, startDate, endDate, etc.
  return await instance.post(
    `attorney/fetch_student_detail/${pageNo}`,
    filters 
  );
};
export const updateArchiveStatus = async (values) => {
  // filters can include: attorneyname, startDate, endDate, etc.
  return await instance.post(
    `attorney/update_archive_status`,
    values 
  );
};
// search student
export const searchClients = async (pageNo, values) => {
  return await instance.post(
    `attorney/fetch_search_student_detail/${pageNo}`,
    values
  );
};

export const locateCertificate = async (values) => {
  return await instance.post(`attorney/locate_certificate`, values);
};
export const attorneyCheck = async (values) => {
  return await instance.post(`attorney/attorney_check`, values);
};
// client Card request
export const sendClientCardRequest = async (values) => {
  return await instance.post(`attorney/clientCard`, values);
};

// report issue
export const sendIssueReport = async (values) => {
  return await instance.post(`attorney/report_issue`, values);
};

// report issue
export const makeSuggestion = async (values) => {
  return await instance.post(`attorney/send_suggestion`, values);
};

// report issue
export const leaveTestimonial = async (values) => {
  return await instance.post(`attorney/send_testimonial`, values);
};

// update attorney profile
export const updateAttorney = async (id, values) => {
  return await instance.post(`attorney/edit_account/${id}`, values);
};

//UnEnroll
export const UnEnroll = async (values) => {
  return await instance.post(`admin/unenrol_user`, values);
};

export const UnEnrollRetake = async (values) => {
  return await instance.post(`admin/cancel-retake-course`, values);
};

export const updateAssociateAttorney = async (values)=>{
  return await instance.post(`user/associate_attorney/`, values);

}

export const updateAdminAssociateAttorney = async (values)=>{
  return await instance.post(`admin/associate_attorney/`, values);

}

export const changePasswordByAdmin = async (values) => {
  return await instance.post("admin/change-password", values)
}

export const getTrusteeInfo = async () => {
  return await instance.get(`admin/get_trustee_info`);
};

export const updateTrusteeInfo = async (values) => {
  return await instance.post("admin/update_trustee_info", values)
}

export const AddStaff = async (values) => {
  return await instance.post("admin/add_staff", values)
}
